import React from "react";

function Tra() {
  return (
    <div>
      Lorem ipsum dolor sit amet consectetur, adipisicing elit. Et, animi. Error
      corrupti sequi dolores, tempore nisi ipsam odit. Sunt culpa mollitia error
      quia asperiores neque odio eum deserunt animi magni, obcaecati iste autem
      corporis est quod libero enim perferendis fuga. Error porro officia
      voluptate rerum ratione culpa, alias voluptatem dolor sed, corrupti
    </div>
  );
}

export default Tra;
